import axios from 'axios';

import { getEnvironment } from '@global/helpers';
const Config = getEnvironment();

const baseUrl = Config.MS_B2B_API_URL;

const salesmanDashboardUrl = `${baseUrl}/dashboards/activities/salesman`;

const getMarketType = (params = {}) => {
  return axios.get(`${baseUrl}/market-types`, params);
};

const getAllMarketType = (params = {}) => {
  return axios.get(`${baseUrl}/market-types/all`, params);
};

const getMarketTypeDetail = (id) => {
  return axios.get(`${baseUrl}/market-types/${id}`);
};

const getMarketTypeCount = (params = {}) => {
  return axios.get(`${baseUrl}/market-types/count`, params);
};

const createMarketType = (payload = {}) => {
  return axios.post(`${baseUrl}/market-types`, payload);
};

const updateMarketType = (id, payload = {}) => {
  return axios.put(`${baseUrl}/market-types/${id}`, payload);
};

const exportMarketType = (params = {}) => {
  return axios.get(`${baseUrl}/market-types/csv-export`, params);
};

const getPlanogram = (params = {}) => {
  return axios.get(`${baseUrl}/planogram`, params);
};

const getPlanogramDetail = (id) => {
  return axios.get(`${baseUrl}/planogram/${id}`);
};

const getPlanogramCount = (params = {}) => {
  return axios.get(`${baseUrl}/planogram/count`, params);
};

const createPlanogram = (payload = {}) => {
  return axios.post(`${baseUrl}/planogram`, payload);
};

const updatePlanogram = (id, payload = {}) => {
  return axios.put(`${baseUrl}/planogram/${id}`, payload);
};

const getTasks = (params = {}) => {
  return axios.get(`${baseUrl}/tasks`, params);
};

const updateActivityTask = (id, payload = {}) => {
  return axios.put(`${baseUrl}/activities/${id}/tasks/invoices`, payload);
};

const getNotifications = (params = {}) => {
  return axios.get(`${baseUrl}/user/me/notifications`, params);
};

const setNotificationReaded = (params = {}) => {
  return axios.put(`${baseUrl}/user/me/notifications`, params);
};

const getNotificationsCount = (params = {}) => {
  return axios.get(`${baseUrl}/user/me/notifications/count`, params);
};

const getComments = (params = {}) => {
  return axios.get(`${baseUrl}/comments`, params);
};

const getCommentsCount = (params = {}) => {
  return axios.get(`${baseUrl}/comments/count`, params);
};

const createComment = (payload = {}) => {
  return axios.post(`${baseUrl}/comments`, payload);
};

const updateComment = (id, payload = {}) => {
  return axios.put(`${baseUrl}/comments/${id}`, payload);
};

const deleteComment = (id) => {
  return axios.delete(`${baseUrl}/comments/${id}`);
};

const getActivities = (params = {}) => {
  return axios.get(`${baseUrl}/activities`, params);
};

const getActivitiesDetail = (id) => {
  return axios.get(`${baseUrl}/activities/${id}`);
};

const getActivitiesCount = (params = {}) => {
  return axios.get(`${baseUrl}/activities/count`, params);
};

const getActivitiesCountAll = (params = {}) => {
  return axios.get(`${baseUrl}/activities/count/all`, params);
};

const getActivitiesTodos = (id, params = {}) => {
  return axios.get(`${baseUrl}/activities/${id}/tasks`, params);
};

const getInvoiceCollectionExport = (params = {}) => {
  return axios.get(`${baseUrl}/activities/invoice-collection-export`, params);
};

const createSalesActivity = (payload = {}) => {
  return axios.post(`${baseUrl}/activities`, payload);
};

const importSalesActivityCsv = (payload = {}) => {
  return axios.post(
    `${baseUrl}/csv-imports/bulk-create-sales-activity`,
    payload,
  );
};

const exportActivityReport = (payload = {}, params = {}) => {
  return axios.post(`${baseUrl}/activities/report`, payload, params);
};

const updateSalesActivity = (id, payload = {}) => {
  return axios.put(`${baseUrl}/activities/${id}`, payload);
};

const updateSalesActivityStatus = (id, status, payload = {}) => {
  return axios.put(`${baseUrl}/activities/${id}/${status}`, payload);
};

const deleteActivity = (id, payload = {}) => {
  return axios.delete(`${baseUrl}/activities/${id}`, payload);
};

const activityCheckin = (id, payload) => {
  return axios.put(`${baseUrl}/activities/${id}/checkin`, payload);
};

const activityCheckout = (id) => {
  return axios.put(`${baseUrl}/activities/${id}/checkout`, {
    is_check_out: true,
    status: 'finished',
  });
};

const updateActivityLocationCustomer = (
  id,
  customerId,
  addressId,
  payload = {},
) => {
  return axios.put(
    `${baseUrl}/activities/${id}/customers/${customerId}/addresses/${addressId}`,
    payload,
  );
};

const getActivityTodosDetail = (id, taskId, payload = {}) => {
  return axios.get(`${baseUrl}/activities/${id}/tasks/${taskId}`, payload);
};

const activityTodosUpdate = (id, taskId, payload = {}) => {
  return axios.put(`${baseUrl}/activities/${id}/tasks/${taskId}`, payload);
};

const activityTodosTypeUpdate = (id, taskId, activityType, payload = {}) => {
  return axios.post(
    `${baseUrl}/activities/${id}/tasks/${taskId}/${activityType}`,
    payload,
  );
};

const deleteVisibilityUpdateProduct = (id, taskId, productId, payload = {}) => {
  return axios.delete(
    `${baseUrl}/activities/${id}/tasks/${taskId}/visibility_update/${productId}`,
    payload,
  );
};

const getSalesTeam = (params) => {
  return axios.get(`${baseUrl}/sales-team`, params);
};

const getSalesTeamDetail = (id) => {
  return axios.get(`${baseUrl}/sales-team/${id}`);
};

const getSalesTeamCount = (params = {}) => {
  return axios.get(`${baseUrl}/sales-team/count`, params);
};

const createSalesTeam = (payload = {}) => {
  return axios.post(`${baseUrl}/sales-team`, payload);
};

const updateSalesTeam = (id, payload = {}) => {
  return axios.put(`${baseUrl}/sales-team/${id}`, payload);
};

export const exportLoyaltyPoint = (payload = {}) => {
  return axios.post(`${baseUrl}/loyalty-point/exports`, payload);
};

export const exportCsv = (type, payload = {}) => {
  return axios.post(`${baseUrl}/${type}/exports`, payload);
};

export const getExportStatus = (type, key) => {
  return axios.post(`${baseUrl}/${type}/exports/status`, { key });
};

// .........customer cluster rule
const getCustomerClusterRule = (params = {}) => {
  return axios.get(`${baseUrl}/customer-cluster-rule`, params);
};

const getCustomerClusterRuleDetail = (id) => {
  return axios.get(`${baseUrl}/customer-cluster-rule/${id}`);
};

const getCustomerClusterRuleCount = (params = {}) => {
  return axios.get(`${baseUrl}/customer-cluster-rule/count`, params);
};

const createCustomerClusterRule = (payload = {}) => {
  return axios.post(`${baseUrl}/customer-cluster`, payload);
};

const updateCustomerClusterRule = (id, payload = {}) => {
  return axios.put(`${baseUrl}/customer-cluster-rule/${id}`, payload);
};

const getSalesOrder = (params = {}) => {
  return axios.get(`${baseUrl}/orders/search`, params);
};

const searchSalesOrderCount = (params = {}) => {
  return axios.get(`${baseUrl}/orders/search/count`, params);
};

const getReturnOrder = (params = {}) => {
  return axios.get(`${baseUrl}/return-orders`, params);
};

const searchReturnOrder = (params = {}) => {
  return axios.get(`${baseUrl}/return-orders/search`, params);
};

const searchReturnOrderCount = (params = {}) => {
  return axios.get(`${baseUrl}/return-orders/search/count`, params);
};

export const getDashboard = (params = {}, type) => {
  return axios.get(`${baseUrl}/dashboards/${type}`, params);
};

export const getDashboardCount = (params = {}, type) => {
  return axios.get(`${baseUrl}/dashboards/${type}/count`, params);
};

export const getDashboardSum = (params = {}, type) => {
  return axios.get(`${baseUrl}/dashboards/${type}/sum`, params);
};

export const getBeautyAdvisorDashboard = (params = {}) => {
  return axios.get(`${baseUrl}/dashboards/activities/beauty-advisor`, params);
};

export const getPromotorDashboard = (params = {}) => {
  return axios.get(`${baseUrl}/dashboards/activities/promotor`, params);
};

export const getSalesmanDashboardSummary = (params = {}) => {
  return axios.get(`${salesmanDashboardUrl}/summary`, params);
};

export const getSalesmanDashboardReceivables = (params = {}) => {
  return axios.get(`${salesmanDashboardUrl}/receivables`, params);
};

export const getSalesmanDashboardArBySalesman = (params = {}) => {
  return axios.get(`${salesmanDashboardUrl}/ar-by-salesman`, params);
};

export const getSalesmanDashboardVisitTrend = (params = {}) => {
  return axios.get(`${salesmanDashboardUrl}/visit-trend`, params);
};

export const getSalesmanDashboardPerformingSalesman = (params = {}) => {
  return axios.get(`${salesmanDashboardUrl}/performing-salesman`, params);
};

export const getCustomersFromEs = (params = {}) => {
  return axios.get(`${baseUrl}/customers/search`, params);
};

export const getCustomersCountFromEs = (params = {}) => {
  return axios.get(`${baseUrl}/customers/search/count`, params);
};

export const getProductsFromEs = (params = {}) => {
  return axios.get(`${baseUrl}/products/search`, params);
};

export const getProductsCountFromEs = (params = {}) => {
  return axios.get(`${baseUrl}/products/search/count`, params);
};

// .........matrix approval
export const getMatrixApproval = (params = {}) => {
  return axios.get(`${baseUrl}/matrix-approval`, params);
};

export const getMatrixApprovalDetail = (id) => {
  return axios.get(`${baseUrl}/matrix-approval/${id}`);
};

export const getMatrixApprovalCount = (params = {}) => {
  return axios.get(`${baseUrl}/matrix-approval/count`, params);
};

export const createMatrixApproval = (payload = {}) => {
  return axios.post(`${baseUrl}/matrix-approval`, payload);
};

export const deleteMatrixApproval = (id) => {
  return axios.delete(`${baseUrl}/matrix-approval/${id}`);
};

export const updateMatrixApproval = (id, payload = {}) => {
  return axios.put(`${baseUrl}/matrix-approval/${id}`, payload);
};

export const createMatrixTier = (id, payload = {}) => {
  return axios.post(`${baseUrl}/matrix-approval/${id}/tier`, payload);
};

export const updateMatrixTier = (idMatrix, idTier, payload = {}) => {
  return axios.put(
    `${baseUrl}/matrix-approval/${idMatrix}/tier/${idTier}`,
    payload,
  );
};

export const deleteMatrixTier = (idMatrix, idTier) => {
  return axios.delete(`${baseUrl}/matrix-approval/${idMatrix}/tier/${idTier}`);
};

export const actionMarketTypeProduct = (
  marketTypeId,
  businessTypeId,
  payload = {},
) => {
  return axios.post(
    `${baseUrl}/market-types/${marketTypeId}/business-types/${businessTypeId}/products`,
    payload,
  );
};

export const deleteMarketTypeProduct = (
  marketTypeId,
  businessTypeId,
  accountId,
  productId,
  combinationId,
  payload = {},
) => {
  return axios.delete(
    `${baseUrl}/market-types/${marketTypeId}/business-types/${businessTypeId}/accounts/${accountId}/products/${productId}/combinations/${combinationId}`,
    payload,
  );
};

export const deleteBusinessTypeProduct = (
  marketTypeId,
  businessTypeId,
  productId,
  combinationId,
  payload = {},
) => {
  return axios.delete(
    `${baseUrl}/market-types/${marketTypeId}/business-types/${businessTypeId}/products/${productId}/combinations/${combinationId}`,
    payload,
  );
};

export const getProducts = (marketTypeId, businessTypeId, params = {}) => {
  return axios.get(
    `${baseUrl}/market-types/${marketTypeId}/business-types/${businessTypeId}/products`,
    params,
  );
};

export const getBrands = (marketTypeId, businessTypeId, params = {}) => {
  return axios.get(
    `${baseUrl}/market-types/${marketTypeId}/business-types/${businessTypeId}/brands`,
    params,
  );
};

export const createBusinnesTypeProductBulk = (
  id,
  businessTypeId,
  payload = {},
) => {
  return axios.post(
    `${baseUrl}/market-types/${id}/business-types/${businessTypeId}/products/bulk`,
    payload,
  );
};

export const createMarketTypeProductBulk = (id, payload = {}) => {
  return axios.post(
    `${baseUrl}/market-types/account-groups/${id}/products/bulk`,
    payload,
  );
};

const getProductSearch = (type, params = {}) => {
  return axios.get(`${baseUrl}/${type}/search`, params);
};

const getCustomerSearch = (params = {}) => {
  return axios.get(`${baseUrl}/customers/search`, params);
};

const getSourcerSearch = (params = {}) => {
  return axios.get(`${baseUrl}/orders/search`, params);
};

const exportActivityCsv = (id, activityType) => {
  return axios.post(`${baseUrl}/activities/${id}/type/${activityType}/report`);
};

const getOtherBrands = (id, params = {}) => {
  return axios.get(`${baseUrl}/activities/${id}/other-brands`, params);
};

const getOtherProducts = (id, params = {}) => {
  return axios.get(`${baseUrl}/activities/${id}/other-products`, params);
};

const getTargetSetting = (params = {}) => {
  return axios.get(`${baseUrl}/target-settings`, params);
};

const getTargetSettingByLevel = (type, level, params = {}) => {
  return axios.get(
    `${baseUrl}/target-settings/targets/${type}/levels/${level}`,
    params,
  );
};

const getAllTargetSettingByLevel = (type, level, params = {}) => {
  return axios.get(
    `${baseUrl}/target-settings/targets/${type}/levels/${level}/all`,
    params,
  );
};

const uploadTargetSetting = (payload = {}) => {
  return axios.post(`${baseUrl}/target-settings`, payload);
};

const createTargetSetting = (payload = {}) => {
  return axios.post(`${baseUrl}/target-settings/new`, payload);
};

const updateTargetSetting = (id, payload = {}) => {
  return axios.put(`${baseUrl}/target-settings/${id}`, payload);
};

const updateStatusTargetSetting = (target, level, status, payload = {}) => {
  return axios.put(
    `${baseUrl}/target-settings/targets/${target}/levels/${level}/status/${status}`,
    payload,
  );
};

const deleteTargetSetting = (target, level, payload = {}) => {
  return axios.delete(
    `${baseUrl}/target-settings/targets/${target}/levels/${level}`,
    payload,
  );
};

const getSkpInternal = (params = {}) => {
  return axios.get(`${baseUrl}/skp-internals/search`, params);
};

const getSkpInternalCount = (params = {}) => {
  return axios.get(`${baseUrl}/skp-internals/search/count`, params);
};

const getSkpExternal = (params = {}) => {
  return axios.get(`${baseUrl}/skp-externals/search`, params);
};

const getSkpExternalCount = (params = {}) => {
  return axios.get(`${baseUrl}/skp-externals/search/count`, params);
};

const getCoaTaxes = (params = {}) => {
  return axios.get(`${baseUrl}/coa-taxes/search`, params);
};

const getCoaTaxesCount = (params = {}) => {
  return axios.get(`${baseUrl}/coa-taxes/search/count`, params);
};

const getVisibilityProductStock = (
  customerAddressId,
  productId,
  combinationId,
) => {
  return axios.get(
    `${baseUrl}/tasks/address/${customerAddressId}/product/${productId}/combination/${combinationId}`,
  );
};

const sendPdfEmail = (type, url) => {
  return axios.post(`${baseUrl}/pdf/${type}`, {
    url,
  });
};

const getPromotionAccounts = (params = {}) => {
  return axios.get(`${baseUrl}/promotion-accounts`, params);
};

const getPromotionAccountById = (id) => {
  return axios.get(`${baseUrl}/promotion-accounts/${id}`);
};

const getPromotionAccountsCount = (params = {}) => {
  return axios.get(`${baseUrl}/promotion-accounts/count`, params);
};

const createPromotionAccount = (payload = {}) => {
  return axios.post(`${baseUrl}/promotion-accounts`, payload);
};

const updatePromotionAccount = (id, payload = {}) => {
  return axios.put(`${baseUrl}/promotion-accounts/${id}`, payload);
};

const deletePromotionAccount = (id) => {
  return axios.delete(`${baseUrl}/promotion-accounts/${id}`);
};

const duplicatePromotionAccount = (id, payload = {}) => {
  return axios.post(`${baseUrl}/promotion-accounts/${id}/duplicate`, payload);
};

const importPromotionAccounts = (payload = {}) => {
  return axios.post(`${baseUrl}/promotion-accounts/import`, payload);
};

const importPromotionAccountProducts = (payload = {}) => {
  return axios.post(`${baseUrl}/promotion-accounts/import-products`, payload);
};

const getSkpInternalBudgetSuggestion = (params = {}) => {
  return axios.get(`${baseUrl}/transaction-sales/budget-suggestion`, params);
};

export const MsB2b = {
  getMarketType,
  getAllMarketType,
  getMarketTypeDetail,
  getMarketTypeCount,
  createMarketType,
  updateMarketType,
  exportMarketType,
  getPlanogram,
  getPlanogramDetail,
  getPlanogramCount,
  createPlanogram,
  updatePlanogram,
  getTasks,
  getNotifications,
  setNotificationReaded,
  getNotificationsCount,
  getActivities,
  getActivitiesDetail,
  getActivitiesCount,
  getActivitiesCountAll,
  getActivitiesTodos,
  getInvoiceCollectionExport,
  createSalesActivity,
  importSalesActivityCsv,
  updateSalesActivity,
  updateSalesActivityStatus,
  exportActivityReport,
  deleteActivity,
  activityCheckin,
  activityCheckout,
  updateActivityLocationCustomer,
  getActivityTodosDetail,
  activityTodosUpdate,
  activityTodosTypeUpdate,
  deleteVisibilityUpdateProduct,
  getSalesTeam,
  getSalesTeamDetail,
  getSalesTeamCount,
  createSalesTeam,
  updateSalesTeam,
  getCustomerClusterRule,
  getCustomerClusterRuleDetail,
  getCustomerClusterRuleCount,
  updateCustomerClusterRule,
  createCustomerClusterRule,
  exportCsv,
  getExportStatus,
  getSalesOrder,
  getDashboard,
  getDashboardCount,
  getCustomersFromEs,
  getCustomersCountFromEs,
  searchSalesOrderCount,
  searchReturnOrderCount,
  searchReturnOrder,
  getProductsFromEs,
  getProductsCountFromEs,
  getReturnOrder,
  getMatrixApproval,
  getMatrixApprovalDetail,
  getMatrixApprovalCount,
  createMatrixApproval,
  updateMatrixApproval,
  deleteMatrixApproval,
  createMatrixTier,
  updateMatrixTier,
  deleteMatrixTier,
  actionMarketTypeProduct,
  deleteMarketTypeProduct,
  deleteBusinessTypeProduct,
  getProducts,
  getBrands,
  createMarketTypeProductBulk,
  createBusinnesTypeProductBulk,
  getProductSearch,
  exportActivityCsv,
  getOtherBrands,
  getOtherProducts,
  updateActivityTask,
  getTargetSetting,
  getTargetSettingByLevel,
  getAllTargetSettingByLevel,
  uploadTargetSetting,
  createTargetSetting,
  updateTargetSetting,
  updateStatusTargetSetting,
  deleteTargetSetting,
  getCustomerSearch,
  getSourcerSearch,
  getSkpInternal,
  getSkpInternalCount,
  getSkpExternal,
  getSkpExternalCount,
  getCoaTaxes,
  getCoaTaxesCount,
  getVisibilityProductStock,
  sendPdfEmail,
  getPromotionAccounts,
  getPromotionAccountsCount,
  getPromotionAccountById,
  createPromotionAccount,
  updatePromotionAccount,
  deletePromotionAccount,
  duplicatePromotionAccount,
  importPromotionAccounts,
  importPromotionAccountProducts,
  getSkpInternalBudgetSuggestion,
  getComments,
  getCommentsCount,
  createComment,
  updateComment,
  deleteComment,
  getSalesmanDashboardSummary,
  getSalesmanDashboardReceivables,
  getSalesmanDashboardArBySalesman,
  getSalesmanDashboardVisitTrend,
  getSalesmanDashboardPerformingSalesman,
};
